var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-profile-banner" },
    [
      _c("div", { staticClass: "control-panel" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: ["UPLOADING", "UPLOADED"].includes(_vm.banner.status),
                expression: "['UPLOADING', 'UPLOADED'].includes(banner.status)"
              }
            ]
          },
          [
            _c("div", { staticClass: "btn upload-percentage" }, [
              _vm._v("Uploading " + _vm._s(_vm.banner.upload_percentage) + "%")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: [
                  "INITIATED",
                  "CHECKING",
                  "PROCESSING",
                  "COMPLETE"
                ].includes(_vm.banner.status),
                expression:
                  "['INITIATED', 'CHECKING', 'PROCESSING', 'COMPLETE'].includes(banner.status)"
              }
            ]
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.display == "cropper",
                    expression: "display == 'cropper'"
                  }
                ],
                staticClass: "btn",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cropper.relativeZoom(0.1)
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-search-plus" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.display == "cropper",
                    expression: "display == 'cropper'"
                  }
                ],
                staticClass: "btn",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cropper.zoomTo(1)
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-arrows-alt" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.display == "cropper",
                    expression: "display == 'cropper'"
                  }
                ],
                staticClass: "btn",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cropper.relativeZoom(-0.1)
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-search-minus" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.display == "banner" || _vm.display == "cropper",
                    expression: "display == 'banner' || display == 'cropper'"
                  }
                ],
                staticClass: "btn",
                attrs: { title: "Click me to upload new banner" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.uploadNewBanner()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-upload" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowCrossBtn,
                    expression: "isShowCrossBtn"
                  }
                ],
                staticClass: "btn",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeEditing()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-times" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.display == "cropper",
                    expression: "display == 'cropper'"
                  }
                ],
                staticClass: "btn save",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.save()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-check" }),
                _vm._v(" "),
                _c("span", { staticClass: "save-title" }, [_vm._v("Save")])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "banner",
            expression: "display == 'banner'"
          }
        ],
        ref: "banner",
        staticClass: "banner-display"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.display == "dropzone",
              expression: "display == 'dropzone'"
            }
          ],
          class: [
            "upload-dropzone",
            {
              "in-progress": !["INITIATED", "COMPLETE"].includes(_vm.status),
              dragover: _vm.dragover
            }
          ],
          on: {
            click: _vm.onClick,
            drop: function($event) {
              $event.preventDefault()
              return _vm.onDrop($event)
            },
            dragover: function($event) {
              $event.preventDefault()
              _vm.dragover = true
            },
            dragleave: function($event) {
              $event.preventDefault()
              _vm.dragover = false
            }
          }
        },
        [
          _c("input", {
            ref: "fileInput",
            attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
            on: {
              change: function($event) {
                return _vm.selectionProcessing($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.status === "INITIATED"
            ? _c("div", [
                _c("div", { staticClass: "upload-image-title" }, [
                  _c("div", { staticClass: "big-text bold-text" }, [
                    _vm._v("Drag your image here or click to add one")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small-text" }, [
                    _vm._v(
                      "The max file size: " +
                        _vm._s(_vm.maxSize / 1024 / 1024) +
                        " MB"
                    )
                  ])
                ])
              ])
            : _vm.status === "CHECKING"
            ? _c("div", [_vm._v("Checking...")])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("vue-cropper", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "cropper",
            expression: "display == 'cropper'"
          }
        ],
        ref: "cropper",
        staticClass: "vue-cropper",
        attrs: {
          src: _vm.banner.url,
          alt: "Source Image",
          viewMode: 3,
          autoCropArea: 1,
          cropBoxResizable: false,
          cropBoxMovable: false,
          guides: false,
          minCropBoxHeight: 300,
          dragMode: "move"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }